// Admin pages - lazy loaded to reduce bundle size for non-admin users
import { lazy } from 'react';

export const AdminLogin = lazy(() => import('./AdminLogin'));
export const AdminDashboard = lazy(() => import('./Dashboard'));
export const AdminUsers = lazy(() => import('./Users'));
export const AdminDiscover = lazy(() => import('./Discover'));
export const AdminContest = lazy(() => import('./Contest'));
export const AdminAlerts = lazy(() => import('./AlertsConsole'));
export const AdminSocial = lazy(() => import('./Social'));
export const AdminFeatureAdoption = lazy(() => import('./FeatureAdoption'));
export const AdminCustomerCommunications = lazy(() => import('./CustomerCommunications'));
export const AdminCampaigns = lazy(() => import('./Campaigns'));
